export default __webpack_public_path__ + "static/media/garant.e3e71ddc.svg";